/* eslint-disable */
import axios from 'axios'
import { getHeaders } from '../auth/actions'
import { toast } from 'react-toast'
import { 
    GET_ALL_LOCATION_BEGIN,
    GET_ALL_LOCATION_SUCCESS,
    GET_ALL_LOCATION_ERROR,
    ADD_LOCATION_BEGIN,
    ADD_LOCATION_SUCCESS,
    ADD_LOCATION_ERROR,
    GET_LOCATION_BEGIN,
    GET_LOCATION_SUCCESS,
    GET_LOCATION_ERROR,
    UPDATE_LOCATION_BEGIN,
    UPDATE_LOCATION_SUCCESS,
    UPDATE_LOCATION_ERROR,
    DELETE_LOCATION_BEGIN,
    DELETE_LOCATION_SUCCESS,
    DELETE_LOCATION_ERROR
 } from './constants'

const API = process.env.REACT_APP_API_URL

export const getAllLocations = () => async(dispatch) => {
  try {
    dispatch({
      type: GET_ALL_LOCATION_BEGIN
    })
    const headers = dispatch(getHeaders());
    const {data} = await axios.get(`${API}/api/location`, { headers })
    console.log(data.data)

    dispatch({
      type: GET_ALL_LOCATION_SUCCESS, 
      data: data.data
    })
  }
  catch (error) {
    const msg = error.response.data.message;
    toast.error(msg)
    console.log(error)
    dispatch({
      type: GET_ALL_LOCATION_ERROR,
      error: msg
    })
  }
}

export const addLocation = (body) => async(dispatch) => {
    try {
        dispatch({
          type: ADD_LOCATION_BEGIN
        })
        const headers = dispatch(getHeaders());
        const {data} = await axios.post(`${API}/api/location`, body, { headers })
        console.log(data.data)
        toast.success("Location added successfully!")
        dispatch({
          type: ADD_LOCATION_SUCCESS, 
          data: data.data
        })
      }
      catch (error) {
        console.log(error.response)
        const msg = error.response.data.message;
        toast.error(msg)
        dispatch({
          type: ADD_LOCATION_ERROR,
          error: msg
        })
      }
}

export const getLocationWithId = (id) => async(dispatch) => {
  try {
    dispatch({
      type: GET_LOCATION_BEGIN
    })
    const headers = dispatch(getHeaders());
    const {data} = await axios.get(`${API}/api/location/${id}`, { headers })
    console.log(data.data)
    dispatch({
      type: GET_LOCATION_SUCCESS, 
      data: data.data
    })
  }
  catch (error) {
    console.log(error.response)
    const msg = error.response.data.message;
    toast.error(msg)
    dispatch({
      type: GET_LOCATION_ERROR,
      error: msg
    })
  }
}

export const updateLocation = (id, body) => async(dispatch) => {
  try {
    dispatch({
      type: UPDATE_LOCATION_BEGIN
    })
    const headers = dispatch(getHeaders());
    const {data} = await axios.put(`${API}/api/location/${id}`, body, { headers })
    console.log(data.data)
    toast.success("Location updated successfully!")
    dispatch({
      type: UPDATE_LOCATION_SUCCESS, 
      data: data.data
    })
  }
  catch (error) {
    const msg = error.response.data.message;
    toast.error(msg)
    dispatch({
      type: UPDATE_LOCATION_ERROR,
      error: msg
    })
  }
}

export const deleteLocation = (id) => async(dispatch) => {
  try {
    dispatch({
      type: DELETE_LOCATION_BEGIN
    })
    const headers = dispatch(getHeaders());
    const {data} = await axios.delete(`${API}/api/location/${id}`, { headers })
    toast.success("Location deleted successfully!")
    dispatch({
      type: DELETE_LOCATION_SUCCESS, 
      data: data.data
    })
  }
  catch (error) {
    const msg = error.response.data.message;
    toast.error(msg)
    dispatch({
      type: DELETE_LOCATION_ERROR,
      error: msg
    })
  }
}